import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faBuilding,
  faCrown,
  faInfoCircle,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";

const NAV_ITEMS = [
  {
    name: "Home",
    path: "/",
    icon: faHome,
  },
  {
    name: "Properties",
    path: "/properties",
    icon: faBuilding,
  },
  {
    name: "Mayfair",
    path: "/properties/jettymayfair",
    icon: faCrown,
    highlight: true,
  },
  {
    name: "About",
    path: "/aboutus",
    icon: faInfoCircle,
  },
  {
    name: "Contact",
    path: "/contactus",
    icon: faEnvelope,
  },
];

const BottomNavbar = () => {
  const location = useLocation();

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-primary/95 backdrop-blur-lg border-t border-white/10 shadow-2xl px-2 py-1.5 transition-all duration-300">
      <div className="flex items-center justify-around max-w-lg mx-auto">
        {NAV_ITEMS.map((item) => {
          const isActive =
            item.path === "/"
              ? location.pathname === "/"
              : location.pathname.startsWith(item.path);

          return (
            <Link
              key={item.name}
              to={item.path}
              className={`flex flex-col items-center justify-center py-1 px-2 min-w-[60px] rounded-xl transition-all duration-200 ${
                isActive
                  ? "text-secondary font-bold scale-105"
                  : "text-gray-300 hover:text-white"
              }`}
            >
              <div
                className={`relative flex items-center justify-center p-1.5 rounded-full transition-all duration-200 ${
                  isActive ? "bg-white/10" : ""
                }`}
              >
                <FontAwesomeIcon
                  icon={item.icon}
                  className={`text-lg ${
                    isActive ? "text-secondary" : "text-gray-300"
                  }`}
                />
                {item.highlight && (
                  <span className="absolute -top-1 -right-1 flex h-2 w-2">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-secondary opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-secondary"></span>
                  </span>
                )}
              </div>
              <span
                className={`text-[10px] tracking-tight mt-0.5 ${
                  isActive ? "font-bold text-secondary" : "font-medium text-gray-300"
                }`}
              >
                {item.name}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNavbar;
